import { I18nProvider, Refine } from "@refinedev/core";
import { useNotificationProvider } from "@refinedev/mui";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { ColorModeContextProvider } from "./providers/colorProvider";
import { useTranslation } from "react-i18next";
import { dataProvider } from "./providers/dataProvider";
import { useKeycloak } from "@react-keycloak/web";
import { createKeycloakProvider } from "./providers/authProvider";
import { TOptionsBase } from "i18next";
import { Box, LinearProgress } from "@mui/material";
import { getResources } from "./router/navigationItems";
import { BrowserRouter } from "react-router";
import routerBindings, {
  DocumentTitleHandler,
  UnsavedChangesNotifier,
} from "@refinedev/react-router";
import SyncrosaleRouter from "./router/SyncrosaleRouter";

function App() {
  const { t, i18n } = useTranslation();
  const { keycloak, initialized } = useKeycloak();
  const notificationProvider = useNotificationProvider();

  if (!initialized) {
    return <LinearProgress />;
  }

  const i18nProvider: I18nProvider = {
    translate: (key: string, params?: TOptionsBase & Record<string, unknown>) =>
      t(key, params),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };

  return (
    <Box
      lang={
        // This provides the current language to whole app
        // Especially for mui buttons capitalization that was wrong with Turkish
        i18nProvider.getLocale()
      }
    >
      <BrowserRouter>
        <ColorModeContextProvider>
          <CssBaseline />
          <GlobalStyles styles={{ html: { WebkitFontSmoothing: "auto" } }} />
          <Refine
            notificationProvider={notificationProvider}
            dataProvider={dataProvider}
            routerProvider={routerBindings}
            authProvider={createKeycloakProvider(keycloak)}
            resources={getResources()}
            i18nProvider={i18nProvider}
            options={{
              syncWithLocation: true,
              warnWhenUnsavedChanges: true,
              useNewQueryKeys: true,
            }}
          >
            <SyncrosaleRouter />
            <UnsavedChangesNotifier />
            <DocumentTitleHandler />
          </Refine>
        </ColorModeContextProvider>
      </BrowserRouter>
    </Box>
  );
}

export default App;
